"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = _interopRequireDefault(require("../foundational-styles/colors"));

var _fontFamilies = _interopRequireDefault(require("./fontFamilies"));

/**
 * Heading styles.
 * @property {Object} headings.900
 * @property {Object} headings.800
 * @property {Object} headings.700
 * @property {Object} headings.600
 * @property {Object} headings.500 - Default.
 * @property {Object} headings.400
 * @property {Object} headings.300
 * @property {Object} headings.200
 * @property {Object} headings.100
 */
var _default = {
  '900': {
    fontSize: '35px',
    fontWeight: 500,
    lineHeight: '40px',
    letterSpacing: '-0.2px',
    marginTop: 52,
    fontFamily: _fontFamilies.default.display,
    color: _colors.default.text.dark
  },
  '800': {
    fontSize: '29px',
    fontWeight: 500,
    lineHeight: '32px',
    letterSpacing: '-0.2px',
    marginTop: 40,
    fontFamily: _fontFamilies.default.display,
    color: _colors.default.text.dark
  },
  '700': {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
    letterSpacing: '-0.07px',
    marginTop: 40,
    fontFamily: _fontFamilies.default.display,
    color: _colors.default.text.dark
  },
  '600': {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.07px',
    marginTop: 28,
    fontFamily: _fontFamilies.default.display,
    color: _colors.default.text.dark
  },
  '500': {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
    marginTop: 24,
    fontFamily: _fontFamilies.default.ui,
    color: _colors.default.text.dark
  },
  '400': {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
    marginTop: 16,
    fontFamily: _fontFamilies.default.ui,
    color: _colors.default.text.dark
  },
  '300': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0',
    marginTop: 16,
    fontFamily: _fontFamilies.default.ui,
    color: _colors.default.text.dark
  },
  '200': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0',
    marginTop: 16,
    fontFamily: _fontFamilies.default.ui,
    color: _colors.default.text.muted
  },
  '100': {
    fontSize: '11px',
    fontWeight: 400,
    textTransform: 'uppercase',
    lineHeight: '16px',
    letterSpacing: '0.6px',
    marginTop: 16,
    fontFamily: _fontFamilies.default.ui,
    color: _colors.default.text.muted
  }
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/typography/headings.js
// module id = 243
// module chunks = 0